<div class="executions-filters">
  <div class="executions-filters-row">
    <div class="left">
      <app-search-box
        class="filters-search"
        (textOnSelection)="searchSubmitted($event)"
        [placeholder]="'playbooks.searchBoxText' | labelsProvider"
        [startingValue]="pageFilters.search.getFilterValue()"
        [newValueTriggered$]="searchBoxNewValue"
      >
      </app-search-box>
      <app-date-picker
        class="filters-date-picker"
        (dateOnSelection)="lastExecutionSinceSelected($event)"
        label="tableActionsAndFilters.lastExecutionSince"
        [startingValue]="pageFilters.lastExecutionSince.getFilterValue()"
        [newValueTriggered$]="lastExecutionSinceNewValue"
      >
      </app-date-picker>
      <app-date-picker
        class="filters-date-picker"
        (dateOnSelection)="lastExecutionUntilSelected($event)"
        label="tableActionsAndFilters.lastExecutionUntil"
        [startingValue]="pageFilters.lastExecutionUntil.getFilterValue()"
        [newValueTriggered$]="lastExecutionUntilNewValue"
        [minDate]="pageFilters.lastExecutionSince.getFilterValue()"
      >
      </app-date-picker>
      <app-multi-select-v2
        class="filters-all"
        (optionOnSelection)="tablesFiltersChange($event)"
        [pageFilters]="pageFilters"
      >
      </app-multi-select-v2>
    </div>
  </div>
  <app-view-filters-multi-select [pageFilters]="pageFilters"></app-view-filters-multi-select>
</div>
